import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Home Testing: the kit dashboard and the employee list.
 *
 * Built on the Vitall partner's kit orders. What a test found — the biomarker
 * values, the report and the clinical comments — is never surfaced anywhere in
 * this section, at company level or per person.
 */
const CompanyHomeTestingLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Testing Dashboard',
      path: `/${slug}/home-testing`,
      description:
        'Kit volume, what is still out, how long each leg takes and which tests get chosen'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/home-testing/users`,
      description: `Per-${population.replace(/s$/, '')} kit records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Home Testing"
      subtitle={`Which test kits your ${population} order, how many make it back to the lab, and how long the wait is.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyHomeTestingLayout;
